<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-data-table
				class="elevation-1"
				:headers="headers"
				:items="records"
				hide-default-footer
				:loading="loading"
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">المجدولة</v-toolbar-title>
						<v-divider insert vertical></v-divider>
					</v-toolbar>
				</template>

				<template #[`item.title`]="{ item }">
					<router-link class="primary--text" :to="{ name: 'event', params: { recordID: item.eventID } }">
						{{ item.title }}
					</router-link>
				</template>

				<template #[`item.userName`]="{ item }">
					<router-link class="primary--text" :to="{ name: 'dashboard-profile', params: { id: item.userID } }">
						{{ item.userName }}
					</router-link>
				</template>
				
				<template #[`item.actions`]="{ item }">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon :loading="loading" v-on="on" @click="deleteScheduled(item)">
								<v-icon>mdi-trash-can</v-icon>
							</v-btn>
						</template>
						<span>حذف الجدولة</span>
					</v-tooltip>
				</template>
			</v-data-table>

			<v-pagination v-model="page" :length="pageCount" class="pt-3"></v-pagination>
		</v-container>
	</div>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier"

export default {
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: "الفعاليات", exact: true, to: { name: "dashboard-events" } },
				{ text: 'المجدولة', disabled: true }
			],
			headers: [
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "المجدول",
					value: "userName"
				},
				{
					text: "وقت وتاريخ الجدولة",
					value: "actionDate"
				},
				{
					text: "العمليات",
					value: "actions"
				},
			],
			records: [],
			pageCount: 1,
			page: 1,
			loading: true,
			actionLoading: false,
		};
	},
	watch: {
		page(newVal) {
			this.loading = true;
			this.records = [];
			this.getRecords(newVal);
		}
	},
	mounted() {
		this.getRecords(1);
	},
	methods: {
		getRecords(page) {
			client
				.get("/api/schedule/events?page=" + page)
				.then(response => {
					this.pageCount = response.data.data.last_page;
					this.records = Object.values(response.data.data.data)
						.map(record => {
							record.title = record.eventTitle;
							return record;
						});
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		async deleteScheduled(item) {
			const confirmed = await this.$refs.confirm.open({
				title: 'تأكيد الحذف',
				message: 'هل تريد حقاً حذف هذه الفعالية؟',
			})
			if (!confirmed) {
				return
			}
			
			this.loading = true
			clientNotifier
				.delete("/api/schedule/events/delete/" + item.scheduleID)
				.then(() => {
					this.getRecords(this.page)
				})
				.catch((e) => {
					console.log(e)
					this.loading = false
				});
		}
	}
};
</script>